var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.desserts,"items-per-page":10,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.status",fn:function({}){return [_c('v-btn',{staticClass:"green2",attrs:{"rounded":"","dense":"","small":"","outlined":"","color":"primary"}},[_vm._v("Active")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }